import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './PostsPage.css';

function PostsPage() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    let apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    axios.get(`${apiBaseUrl}/posts`)
      .then((response) => {
        setPosts(response.data);
      })
      .catch((error) => {
        console.error('Error fetching posts:', error);
      });
  }, []);

  return (
    <div className="PostsContainer">
      {posts.map((post) => {
        const postedByUsername = post.creatorId?.username || 'Unknown';

        // 1. Convert the post’s publishedDate to a JS Date
        const published = new Date(post.publishedDate);

        // 2. Format the date and time
        const dateString = published.toLocaleDateString(); // e.g. "11/18/2025"
        const timeString = published.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Etc/GMT-3', // force GMT+3
        });

        return (
          <Link to={`/posts/${post._id}`} key={post._id} className="LinkContainer">
            <div className="PostBox">
              <h2 className="PostTitle">{post.title}</h2>

              {/* The bottom-left "date/hour" info */}
              <div className="DateAndHour">
                <div>Date posted: {dateString}</div>
                <div>Hour posted (GMT+3): {timeString}</div>
              </div>

              {/* The bottom-right "posted by" */}
              <div className="PostedBy">
                posted by: {postedByUsername}
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
}

export default PostsPage;
